import React, { useEffect, useState, useRef } from 'react';
import { X, Lock } from 'lucide-react';
interface AdminLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUnlock: () => void;
}
export function AdminLoginModal({
  isOpen,
  onClose,
  onUnlock
}: AdminLoginModalProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isOpen) {
      setPassword('');
      setError('');
      // Small delay to ensure render before focus
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '123456') {
      onUnlock();
    } else {
      setError('Incorrect password. Try again.');
      setPassword('');
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-87">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-88">
        <div className="p-6" data-id="element-89">
          <div className="flex justify-between items-center mb-6" data-id="element-90">
            <h2 id="modal-title" className="text-xl font-semibold text-gray-900 flex items-center gap-2" data-id="element-91">
              <Lock className="w-5 h-5 text-gray-400" data-id="element-92" />
              Admin Login
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-50" aria-label="Close modal" data-id="element-93">
              <X className="w-5 h-5" data-id="element-94" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-95">
            <div data-id="element-96">
              <label htmlFor="password" className="sr-only" data-id="element-97">
                Password
              </label>
              <input ref={inputRef} type="password" id="password" value={password} onChange={e => {
              setPassword(e.target.value);
              setError('');
            }} placeholder="Enter admin password" className={`
                  w-full px-4 py-3 rounded-lg border bg-gray-50 focus:bg-white transition-colors outline-none focus:ring-2 focus:ring-black/5
                  ${error ? 'border-red-300 focus:border-red-500' : 'border-gray-200 focus:border-gray-400'}
                `} data-id="element-98" />
              {error && <p className="mt-2 text-sm text-red-600 flex items-center gap-1 animate-in slide-in-from-top-1" data-id="element-99">
                  {error}
                </p>}
            </div>

            <div className="flex gap-3 pt-2" data-id="element-100">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 rounded-lg border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition-colors" data-id="element-101">
                Cancel
              </button>
              <button type="submit" className="flex-1 px-4 py-2.5 rounded-lg bg-black text-white font-medium hover:bg-gray-800 transition-colors shadow-lg shadow-black/10" data-id="element-102">
                Unlock
              </button>
            </div>
          </form>
        </div>
        <div className="bg-gray-50 px-6 py-3 border-t border-gray-100 text-center" data-id="element-103">
          <p className="text-xs text-gray-400" data-id="element-104">
            Hint: The password is Justin's favorite color.
          </p>
        </div>
      </div>
    </div>;
}